export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-problem-1.4182ffc0.png";